module.exports = __webpack_public_path__ + "img/H15.dee92690.jpg";